import { isPlatformBrowser } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';  
import * as confetti from 'canvas-confetti';  

@Injectable({  
  providedIn: 'root'  
})  
export class ConfettiService {  
  private intervalId: any;  
  private fireworksCount = 0;  
  private maxFireworks = 100;  
  private canvas: HTMLCanvasElement | null = null;  
  private isPaused = false;  

  constructor(@Inject(PLATFORM_ID) private platformId: Object) {  
      if (isPlatformBrowser(this.platformId)) {  
          //safe now to use document
          document.addEventListener('visibilitychange', this.handleVisibilityChange.bind(this));  
      }
  }  

  private handleVisibilityChange() {  
    if (isPlatformBrowser(this.platformId)) {  
      //safe now to use document
      if (document.hidden) {  
        this.pauseFireworks();  
      } else {  
        this.resumeFireworks();  
      }  
    }
  }  

  startFireworks(parentElement: HTMLElement) {  
    if (isPlatformBrowser(this.platformId)) {  
      //safe now to use document
      this.canvas = document.createElement('canvas');  
      parentElement.appendChild(this.canvas);  

      // Set canvas styles to fill the parent element  
      this.canvas.style.position = 'absolute';  
      this.canvas.style.top = '0';  
      this.canvas.style.left = '0';  
      this.canvas.style.width = '100%';  
      this.canvas.style.height = '100%';  
      this.canvas.style.pointerEvents = 'none'; // Ensure it doesn't block interactions  

      const myConfetti = confetti.create(this.canvas, {  
        resize: true, // will fit all screen sizes  
        useWorker: true // will use a worker to improve performance  
      });  

      this.intervalId = setInterval(() => {  
        if (!this.isPaused && this.fireworksCount < this.maxFireworks) {  
          myConfetti({  
            particleCount: 100,  
            spread: 160,  
            origin: {  
              x: Math.random(), // Random horizontal position  
              y: Math.random() * 0.5 // Random vertical position (top half of the screen)  
            }  
          });  
          this.fireworksCount++;  
        }  
      }, 1000); // Adjust the interval as needed  
    }
  }  

  pauseFireworks() {  
    this.isPaused = true;  
  }  

  resumeFireworks() {  
    this.isPaused = false;  
  }  

  stopFireworks() {  
    if (this.intervalId) {  
      clearInterval(this.intervalId);  
      this.intervalId = null;  
    }  
    if (this.canvas && this.canvas.parentElement) {  
      this.canvas.parentElement.removeChild(this.canvas);  
    }  
    this.canvas = null;  
    this.fireworksCount = 0;  
  }  
}  
